import { queryKeys } from '@/lib/query-keys';
import { orderClient } from '@/lib/api/ts-rest';
import type { Order } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';


export const useAdminOrders = () => {
  return useQuery<Order[], Error>({
    queryKey: queryKeys.orders.list(),
    queryFn: async () => {
      const res = await orderClient.listOrders();
      if (res.status !== 200) throw new Error('Failed to load orders');
      return res.body;
    },
  });
};

export const useOrders = (organizationId: string | undefined) => {
  return useQuery<Order[], Error>({
    queryKey: queryKeys.orders.list(organizationId),
    queryFn: async () => {
      const res = await orderClient.listMyOrders({
        query: { organizationId: organizationId! },
      });
      if (res.status !== 200) throw new Error('Failed to load orders');
      return res.body;
    },
    enabled: !!organizationId,
  });
};

export const useOrderDetails = (orderId: string) => {
  return useQuery<Order, Error>({
    queryKey: queryKeys.orders.detail(orderId),
    queryFn: async () => {
      const res = await orderClient.getOrder({ params: { id: orderId } });
      if (res.status !== 200) throw new Error('Failed to load order');
      return res.body;
    },
  });
};
